import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { ChevronDownIcon, MenuIcon, PhoneCallIcon, XIcon } from 'lucide-react';
import { NAV } from '../../data/site';
import { Container } from '../ui/Section';
import { trackCta } from '../../utils/tracking';
export function Header() {
  const [open, setOpen] = useState(false);
  const [solutionsOpen, setSolutionsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
    setSolutionsOpen(false);
  }, [location.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const solutions = NAV.find(n => n.label === 'Soluciones')?.children ?? [];
  return <header className={`sticky top-0 z-50 border-b transition-colors duration-200 ease-smooth ${scrolled ? 'border-mist-200 bg-white/95 backdrop-blur' : 'border-transparent bg-white'}`} data-id="element-404" data-mp="3ufv1qkt08bas">
      <Container className="flex h-[72px] items-center justify-between gap-6" data-id="element-405" data-mp="bsx8s5fkrl9t">
        <Link to="/" className="flex items-center gap-3" aria-label="Rabemar Servicios Integrales — Inicio" data-id="element-406" data-mp="gmt0iq58wbwj">
          <span className="flex h-9 w-9 items-center justify-center bg-brand-700 font-display text-lg font-bold text-white" data-id="element-407" data-mp="lk1nd41c9444">R</span>
          <span className="leading-none" data-id="element-408" data-mp="3k4jjol1hsg61">
            <span className="block font-display text-lg font-bold tracking-tightest text-graphite-900" data-id="element-409" data-mp="3p2cs7kq9pm9h">RABEMAR</span>
            <span className="block text-[10px] font-semibold uppercase tracking-[0.2em] text-graphite-500" data-id="element-410" data-mp="3tytesahtjskg">
              Servicios Integrales
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="Navegación principal" data-id="element-411" data-mp="199du7x971039">
          {NAV.filter(item => item.label !== 'Contacto').map(item => item.children ? <div key={item.label} className="relative" onMouseEnter={() => setSolutionsOpen(true)} onMouseLeave={() => setSolutionsOpen(false)} data-id="element-412" data-mp="3ab24h4floc1f">
                <NavLink to={item.to} className={({
            isActive
          }) => `flex items-center gap-1 px-3 py-2 text-sm font-medium transition-colors duration-150 ${isActive ? 'text-brand-700' : 'text-graphite-700 hover:text-brand-700'}`} aria-expanded={solutionsOpen} data-id="element-413" data-mp="3jayyzmoo854e">
                  {item.label}
                  <ChevronDownIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-414" data-mp="2vn8q1n293fkf" />
                </NavLink>
                {solutionsOpen && <div className="absolute left-0 top-full w-[520px] border border-mist-200 bg-white p-2 shadow-xl" data-id="element-415" data-mp="27w3e3izfl7fe">
                    {solutions.map(child => <Link key={child.to} to={child.to} className="block px-4 py-3 transition-colors duration-150 hover:bg-mist-50" data-id="element-416" data-mp="ifpw1207e241">
                        <span className="block text-sm font-semibold text-graphite-900" data-id="element-417" data-mp="9hxfxvmnqqfl">{child.label}</span>
                        <span className="mt-0.5 block text-xs leading-relaxed text-graphite-500" data-id="element-418" data-mp="ed31uug2853o">{child.description}</span>
                      </Link>)}
                  </div>}
              </div> : <NavLink key={item.label} to={item.to} className={({
          isActive
        }) => `px-3 py-2 text-sm font-medium transition-colors duration-150 ${isActive ? 'text-brand-700' : 'text-graphite-700 hover:text-brand-700'}`} data-id="element-419" data-mp="s7dhmma2woxl">
                {item.label}
              </NavLink>)}
        </nav>

        <div className="hidden items-center gap-3 lg:flex" data-id="element-420" data-mp="129ksrh86r04">
          <Link to="/contacto#especialista" onClick={() => trackCta('Hablar con un especialista', 'header')} className="text-sm font-semibold text-graphite-700 transition-colors duration-150 hover:text-brand-700" data-id="element-421" data-mp="3sdro8sb0bmxx">
            Hablar con un especialista
          </Link>
          <Link to="/contacto" onClick={() => trackCta('Solicitar propuesta', 'header')} className="inline-flex items-center gap-2 bg-brand-700 px-5 py-3 text-xs font-bold uppercase tracking-[0.12em] text-white transition-colors duration-150 hover:bg-brand-600" data-id="element-422" data-mp="jyhina7wrzle">
            Solicitar propuesta
          </Link>
        </div>

        <button type="button" className="inline-flex h-11 w-11 items-center justify-center border border-mist-200 text-graphite-800 lg:hidden" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Cerrar menú' : 'Abrir menú'} data-id="element-423" data-mp="2vplfbt71y8du">
          {open ? <XIcon className="h-5 w-5" data-id="element-424" data-mp="2liae962qj2fk" /> : <MenuIcon className="h-5 w-5" data-id="element-425" data-mp="2qj6mfvu4daqs" />}
        </button>
      </Container>

      {open && <div id="mobile-nav" className="border-t border-mist-200 bg-white lg:hidden" data-id="element-426" data-mp="2vayde7h6tihg">
          <Container className="py-4" data-id="element-427" data-mp="2zca46gbss9r8">
            <ul className="divide-y divide-mist-200" data-id="element-428" data-mp="2zb8ilhx5o4v9">
              {NAV.map(item => <li key={item.label} className="py-3" data-id="element-429" data-mp="34a3bxdsr1btm">
                  <Link to={item.to} className="block text-base font-semibold text-graphite-900" data-id="element-430" data-mp="39a7quze0dyhq">
                    {item.label}
                  </Link>
                  {item.children && <ul className="mt-2 space-y-2 pl-3" data-id="element-431" data-mp="1ew6innwkjz4z">
                      {item.children.map(child => <li key={child.to} data-id="element-432" data-mp="1juzuzd04dk3k">
                          <Link to={child.to} className="block text-sm text-graphite-500" data-id="element-433" data-mp="1jvt76thul1t3">
                            {child.label}
                          </Link>
                        </li>)}
                    </ul>}
                </li>)}
            </ul>
            <div className="mt-5 grid gap-3" data-id="element-434" data-mp="1lu2p1jnsh7b8">
              <Link to="/contacto" onClick={() => trackCta('Solicitar propuesta', 'header-mobile')} className="inline-flex items-center justify-center bg-brand-700 px-5 py-4 text-xs font-bold uppercase tracking-[0.12em] text-white" data-id="element-435" data-mp="1gt5634uyg98o">
                Solicitar propuesta
              </Link>
              <Link to="/contacto#especialista" onClick={() => trackCta('Hablar con un especialista', 'header-mobile')} className="inline-flex items-center justify-center gap-2 border border-mist-300 px-5 py-4 text-sm font-semibold text-graphite-800" data-id="element-436" data-mp="24ihh8a9uerdm">
                <PhoneCallIcon className="h-4 w-4" aria-hidden="true" data-id="element-437" data-mp="29gixknfvwcle" />
                Hablar con un especialista
              </Link>
            </div>
          </Container>
        </div>}
    </header>;
}